import React from 'react';
import { CommunicationItem } from '../Presentation/CommunicationItem';
import { modifyData } from '../CommunicationUtilities/communicationUtils';

export const CommunicationComponent = props => {
  const { routingContent = null } = props.contentData;
  const routingData = (routingContent && modifyData(routingContent)) || [];
  /**
   * Method to handle button click on the cards
   */
  const clickHandler = buttonItem => {
    console.log('item selected', buttonItem);
  };
  /**
   * Method to determine if the array item is an even or odd entry
   */
  const showFullWidth = (array, item) => array.length % 2 !== 0 && array.indexOf(item) === array.length - 1;

  // prepare number of cards available to the view of communication
  const cards = routingData.map((item, index, array) => {
    return (
      <CommunicationItem
        key={item.buttonItem}
        data-testid='communicationItem-click'
        contentData={item}
        className={`${showFullWidth(array, item) ? 'communicationCard-full' : ''}`}
        clickHandler={clickHandler}
      />
    );
  });
  return <div className='communication_container'>{cards}</div>;
};

export default CommunicationComponent;
